import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AppService } from '../app.service';
import { Log } from 'ng2-logger';
import { OidcService } from '../auth/oidc.service';

const log = Log.create('Login');

@Component({
  moduleId: module.id,
  selector: 'edit-login',
  template: '<p>Redirecting...</p>',
})

export class LoginComponent implements OnInit, AfterViewInit {

  constructor(
    private appService: AppService,
    private oidcService: OidcService,
  ) {}

  ngOnInit() {
    this.appService.headerData.title = 'Login';
    this.appService.headerData.path = [];
  }

  ngAfterViewInit() {
    log.info("Redirecting to signin");
    this.oidcService.signinRedirect();
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts